/* The Linen Four · "The crease": three pills, three states of a cloth the browser draws. Only the state on show is rendered (the filters are heavy); the next one fades in over it, then the old one is switched off. Without JS the page stays on "After dinner" and the pills are hidden.
   Ink drawings (4 Nov): every [data-ln-anim] SVG (folds, places, ornaments, the crease plate) is drawn finished in the markup. Here, only with JS and without reduced motion, it gets .ln-pre (start state) and then .ln-go once it is well in view: strokes draw on and the flaps fold in order (CSS in spc-linen.css). */
(function () {
  var SAY = ['Very correct. Slightly nervous.', 'Now it looks like somebody ate here.', 'The best it has looked all week.'];
  var HOW = ['lightly', 'softly', 'deeply'];
  var still = (window.SPN && window.SPN.still) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function draw(root) {
    var els = root.querySelectorAll('[data-ln-anim]:not([data-ln-on])');
    if (still || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        io.unobserve(t);
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          t.classList.add('ln-go');
          t.classList.remove('ln-pre');
          if (t.classList.contains('spc-ln-ink')) setTimeout(function () { t.classList.remove('ln-go'); }, 4200);
        }); });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.3 });
    els.forEach(function (el) { el.setAttribute('data-ln-on', ''); el.classList.add('ln-pre'); io.observe(el); });
  }
  function init(root) {
    draw(root);
    var toy = root.querySelector('[data-spc-crease]');
    if (!toy || toy.dataset.on) return;
    toy.dataset.on = '1';
    var lays = toy.querySelectorAll('[data-spc-lay]'), btns = toy.querySelectorAll('[data-spc-pick]'), say = toy.querySelector('[data-spc-say]'), cloth = toy.querySelector('[data-spc-cloth]'), ink = toy.querySelector('.spc-ln-ink');
    var cur = 1, z = 1, t;
    function tidy() {
      lays.forEach(function (l, i) {
        if (i === cur) return;
        l.classList.remove('is-on');
        l.hidden = true;
      });
    }
    function pick(n) {
      if (n === cur) return;
      cur = n;
      clearTimeout(t);
      var next = lays[n];
      next.hidden = false;
      next.style.zIndex = ++z;
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (cur === n) next.classList.add('is-on'); }); });
      btns.forEach(function (b, i) { b.setAttribute('aria-pressed', i === n ? 'true' : 'false'); });
      say.textContent = SAY[n];
      cloth.setAttribute('aria-label', 'A square of natural linen, ' + HOW[n] + ' creased, drawn by this page to show the idea');
      if (ink) ink.setAttribute('data-st', String(n));
      t = setTimeout(tidy, 1300);
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { pick(i); }); });
  }
  function all() { document.querySelectorAll('[data-spc-linen]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
